/*
 * Express checkout area in the cart drawer (snippets/cart-drawer.liquid).
 * Shopify renders the accelerated checkout buttons itself and only for methods available on
 * this device, so the area starts hidden ("is-empty") and the "Or express checkout" divider
 * appears only once a button has real size. Watching size (not markup) also covers Shopify
 * re-rendering the buttons after the cart updates.
 */
(function () {
  function watch(wrapper) {
    var buttons = wrapper.querySelector('[data-kd-express-buttons]');
    if (!buttons || !('ResizeObserver' in window)) {
      wrapper.classList.remove('is-empty');
      return;
    }
    new ResizeObserver(function () {
      wrapper.classList.toggle('is-empty', buttons.offsetHeight < 24);
    }).observe(buttons);
  }

  function init() {
    document.querySelectorAll('[data-kd-express]').forEach(function (wrapper) {
      if (wrapper.dataset.kdExpressReady) return;
      wrapper.dataset.kdExpressReady = 'true';
      watch(wrapper);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
